(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('choicePossRulesRun', {
        templateUrl: 'views/components/views/choicePossRulesRun/choicePossRulesRun.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'modalService', 'choicePossRulesRunService', function (stateService, utilityService, modalService, choicePossRulesRunService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            let progress = {
                runProgress: 'START',
                label: 'progressbar',
                field: '',
                max: 0,
                min: 0,
                step: 0,
                finishclose: '1',
                abortclose: false
            };

            vm.model = {
                choiceProductButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('choice_prod_id') }
                ],
                modelButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('models') }
                ],
                modelButtonsGoto: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('model_id') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('models') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('modelmenu', { model_id: vm.model.setting.model_id }) }
                ],
                bgChoicePossRulesRun: {
                    selected: 'COUNT',
                    buttons: [
                        { id: 'COUNT', label: 'gb_choicepossrulesrun_count', color: 'primary', onClick: () => vm.model.bgChoicePossRulesRun.selected = 'COUNT' },
                        { id: 'PRODUCTS', label: 'gb_choicepossrulesrun_products', color: 'primary', onClick: () => vm.model.bgChoicePossRulesRun.selected = 'PRODUCTS' }
                    ]
                },
                setting: {},
                selectListProductChoices: [],
                selectListModels: [],
                itemsListCounts: [],
                itemsListProducts: [],
                executing: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS

            async function loadChoihcePossRulesRunGet() {
                return vm.model.setting = (await choicePossRulesRunService.getSetting())[0];
            }

            async function loadProductChoices() {
                return vm.model.selectListProductChoices = await choicePossRulesRunService.listProductChoices({ add_all: '1' });
            }

            async function loadModels() {
                return vm.model.selectListModels = await choicePossRulesRunService.listModels({
                    add_all: '1',
                    show_inactive: '0'
                });
            }

            async function loadCounts() {
                if (utilityService.validateParmsValue(vm.model.setting.choice_prod_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.model_id) !== true) return;

                return vm.model.itemsListCounts = await choicePossRulesRunService.listCounts(vm.model.setting);
            }

            async function loadProducts() {
                if (utilityService.validateParmsValue(vm.model.setting.choice_prod_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.model_id) !== true) return;

                return vm.model.itemsListProducts = await choicePossRulesRunService.listProducts(vm.model.setting);
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region RESET BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'choice_prod_id':
                    case 'model_id':
                        vm.model.setting[id] = 'ALL';

                        if (vm.model.setting[id] === 'ALL') {
                            loadCounts();
                            loadProducts();
                        }
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgChoicePossRulesRun = function (value) {
                vm.model.bgChoicePossRulesRun.selected = value;
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            function activateProgress(items) {
                let increment = 1, skip = 0, failed = 0, step = 0;
                progress.step = 0;

                function doStep() {
                    setTimeout(() => {
                        let mergeObj = vm.model.setting;
                        mergeObj.prod_id = items[step].item_id;
                        modalService.progressInfo.finishclose = '0';

                        if (progress.runProgress === 'ABORT') {
                            vm.model.executing = false;
                            return;
                        }

                        if (progress.step >= progress.max) {
                            vm.model.executing = false;
                            return;
                        }

                        if (items[step].item_id === '0' || items[step].item_id === '9999') {
                            skip++;
                            step = progress.step + skip + failed;
                            doStep();
                        } else {
                            step = progress.step + skip + failed;
                            progress.field = items[step].item_name;
                            modalService.progressInfo.field = progress.field;

                            choicePossRulesRunService.executeOneItem(mergeObj).then(() => {
                                progress.step += increment;
                                modalService.progressInfo.step = progress.step;
                                modalService.progressInfo.finishclose = progress.finishclose;

                                doStep();
                            });
                        }
                    });
                }

                doStep();
            }

            vm.addExecutes = function () {
                vm.model.executing = true;

                vm.model.itemsListProducts.forEach((item) => {
                    if (item.item_id !== '0' && item.item_id !== '9999') {
                        progress.max++;
                    } else {
                        vm.model.executing = false;
                        return;
                    }
                });

                if (vm.model.itemsListProducts.length === 0) {
                    vm.model.executing = false;
                    return;
                }

                progress.max = vm.model.itemsListProducts.length;
                activateProgress(vm.model.itemsListProducts);

                modalService.showProgress(progress).then((value) => {
                    progress.runProgress = value;

                    if (progress.runProgress === 'ABORT') {
                        vm.model.executing = false;
                        return;
                    }

                    if (progress.runProgress === 'FINISH') {
                        vm.model.executing = false;
                        loadProducts();
                    }
                });
            };

            // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'choice_prod_id':
                    case 'model_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

                        vm.model.setting[id] = value;

                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        loadCounts();
                        loadProducts();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region LIFE CYCLE FUNCTION

            vm.$onInit = async function () {
                loadProductChoices();
                loadModels();
                await loadChoihcePossRulesRunGet();
                loadCounts();
                loadProducts();
            }

            // #endregion LIFE CYCLE FUNCTION

        }]
    });
})();
